import {FormControl, ModalBody, ModalFooter} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Style from "../Style.module.css";
import React, {useState} from "react";
import * as UserService from "../../api/UserService";

function LoginModal(props) {
    const [email, setEmail] = useState("")
    const [pass, setPass] = useState("")

    function redirectWhenNotAuth() {
        window.alert("Невірний email або пароль")
    }
    function ResolveEmail(event) {
        setEmail(event.target.value)
    }

    function ResolvePass(event) {
        setPass(event.target.value)
    }

    function authorise() {
        UserService.postLoginData(email, pass, ()=>{props.reloadPage()}, redirectWhenNotAuth)
    }

    return (
        <>
            <Modal
                show={true}
                onHide={props.closeModal}
                contentClassName={Style.loginModalContentClassName}

            >
                <ModalBody style={{backgroundColor: "transparent"}}>
                    <div className={Style.setupPageBlocks}>
                        <header>Введіть імейл</header>
                        <FormControl
                            placeholder={"Імейл"}
                            aria-label="Email"
                            aria-describedby="basic-addon1"
                            value={email}
                            onChange={event => ResolveEmail(event)}
                        />
                        <header>Введіть пароль</header>
                        <FormControl
                            placeholder={"Пароль"}
                            aria-label="Password"
                            aria-describedby="basic-addon1"
                            value={pass}
                            onChange={event => ResolvePass(event)}
                            type={"password"}
                        />
                        <br></br>
                        <div style={{display: "flex", alignItems: "center", flexDirection: "column", gap: "12px"}}>
                            <div className={`${Style.defaultButtonColourAndText} ${Style.buttonWithLink}`}
                                 onClick={() => {
                                     authorise()
                                 }}>Увійти
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default LoginModal;
